import {Checkbox} from 'antd'
import {useDiffMapContext} from './DiffMapContext.jsx'

export default function ToggleCompareRef(props) {
    const {noRefRevChgFlag, setNoRefRevChgFlag} = useDiffMapContext()

    const onChange = e => {
        const noRef = e.target.checked ? '1' : '0'
        setNoRefRevChgFlag(noRef)
    }

    return (
        <Checkbox
            checked={'1' === noRefRevChgFlag}
            onChange={onChange}
            {...props}
        >
            非引用版本差异
        </Checkbox>
    )
}
